import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import toast from 'react-hot-toast';
import { Activity, Eye, EyeOff, Lock, Mail } from 'lucide-react';

export default function Login() {
    const { login } = useAuth();
    const navigate = useNavigate();
    const [form, setForm] = useState({ email: '', password: '' });
    const [loading, setLoading] = useState(false);
    const [showPass, setShowPass] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            await login(form.email, form.password);
            navigate('/dashboard');
            toast.success('Welcome back!');
        } catch (err) {
            toast.error(err.response?.data?.message || 'Login failed');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div
            style={{
                minHeight: '100vh',
                background: 'var(--bg)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                position: 'relative',
                overflow: 'hidden',
            }}
        >
            {/* Background decoration */}
            <div
                style={{
                    position: 'absolute',
                    width: 600,
                    height: 600,
                    borderRadius: '50%',
                    top: -200,
                    right: -100,
                    background:
                        'radial-gradient(circle, rgba(59,130,246,0.06) 0%, transparent 70%)',
                    pointerEvents: 'none',
                }}
            />
            <div
                style={{
                    position: 'absolute',
                    width: 400,
                    height: 400,
                    borderRadius: '50%',
                    bottom: -100,
                    left: -100,
                    background:
                        'radial-gradient(circle, rgba(99,102,241,0.06) 0%, transparent 70%)',
                    pointerEvents: 'none',
                }}
            />

            <div
                className="fade-in"
                style={{
                    width: '100%',
                    maxWidth: 420,
                    padding: '0 20px',
                }}
            >
                {/* Logo */}
                <div style={{ textAlign: 'center', marginBottom: 40 }}>
                    <div
                        style={{
                            width: 100,
                            height: 100,
                            borderRadius: 18,
                            margin: '0 auto 16px',
                            /*  background:
                                 'linear-gradient(135deg, var(--accent), var(--accent2))', */
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            /* boxShadow: '0 0 40px rgba(59, 130, 246, 0.2)', */
                        }}
                    >
                        <img src='/logo.jpg' width={100} height={100} />
                    </div>
                    <h1
                        style={{
                            fontFamily: 'Syne',
                            fontWeight: 700,
                            marginBottom: 6,
                        }}
                    >
                       Palav Neo Connect
                    </h1>
                    <p style={{ color: 'var(--text3)', fontSize: 14 }}>
                        Sign in to your admin account
                    </p>
                </div>

                {/* Form */}
                <div className="card" style={{ padding: 32 }}>
                    <form onSubmit={handleSubmit}>
                        <div className="form-group">
                            <label>Email Address</label>
                            <div style={{ position: 'relative' }}>
                                <Mail
                                    size={16}
                                    style={{
                                        position: 'absolute',
                                        left: 12,
                                        top: '50%',
                                        transform: 'translateY(-50%)',
                                        color: 'var(--text3)',
                                    }}
                                />
                                <input
                                    className="input"
                                    type="email"
                                    placeholder="Enter email"
                                    style={{ paddingLeft: 38 }}
                                    value={form.email}
                                    onChange={(e) =>
                                        setForm({
                                            ...form,
                                            email: e.target.value,
                                        })
                                    }
                                    required
                                />
                            </div>
                        </div>

                        <div className="form-group">
                            <label>Password</label>
                            <div style={{ position: 'relative' }}>
                                <Lock
                                    size={16}
                                    style={{
                                        position: 'absolute',
                                        left: 12,
                                        top: '50%',
                                        transform: 'translateY(-50%)',
                                        color: 'var(--text3)',
                                    }}
                                />
                                <input
                                    className="input"
                                    type={showPass ? 'text' : 'password'}
                                    placeholder="Enter password"
                                    style={{
                                        paddingLeft: 38,
                                        paddingRight: 40,
                                    }}
                                    value={form.password}
                                    onChange={(e) =>
                                        setForm({
                                            ...form,
                                            password: e.target.value,
                                        })
                                    }
                                    required
                                />
                                <button
                                    type="button"
                                    onClick={() => setShowPass(!showPass)}
                                    style={{
                                        position: 'absolute',
                                        right: 12,
                                        top: '50%',
                                        transform: 'translateY(-50%)',
                                        background: 'none',
                                        border: 'none',
                                        cursor: 'pointer',
                                        color: 'var(--text3)',
                                    }}
                                >
                                    {showPass ? (
                                        <EyeOff size={16} />
                                    ) : (
                                        <Eye size={16} />
                                    )}
                                </button>
                            </div>
                        </div>

                        <button
                            type="submit"
                            className="btn btn-primary"
                            disabled={loading}
                            style={{
                                width: '100%',
                                justifyContent: 'center',
                                marginTop: 8,
                                padding: '12px 20px',
                            }}
                        >
                            {loading ? (
                                <div
                                    className="spinner"
                                    style={{
                                        width: 18,
                                        height: 18,
                                        borderWidth: 2,
                                    }}
                                />
                            ) : (
                                'Sign In'
                            )}
                        </button>
                    </form>

                    {/* <p
                        style={{
                            textAlign: 'center',
                            fontSize: 12,
                            color: 'var(--text3)',
                            marginTop: 20,
                        }}
                    >
                        Default: admin@quickbook.com / admin@123
                    </p> */}
                </div>
            </div>
        </div>
    );
}
